export default __webpack_public_path__ + "static/media/amazon.7eedcc1f.png";